import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { GlobalAppSettingsSchema } from '../../../../../../../../pb/responses/v1/global_app_settings_response_pb';
import { goBackendApi } from 'hooks/api/httpApi';

export const getAppStatus = async () => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient
        .getRequest(GlobalAppSettingsSchema, '/api/v1/settings/app')
        .then((res) => res)
        .catch((error) => {
            if (error.status === 404) {
                return Promise.resolve(undefined);
            }
            throw error;
        });
};
